// Layouts
import { DefaultLayout, ScreenedLayout } from '@/layouts'

// Import the components
import ContractorProfile from '../views/marketplace/contractor/Profile.vue'
import ContractorProfilePreview from '../views/marketplace/contractor/ProfilePreview.vue'
import ContractorProfileEdit from '../views/marketplace/contractor/ProfileEdit.vue'
import ContractorLogin from '../views/marketplace/contractor/Login.vue'
import ContractorLogout from '../views/marketplace/contractor/Logout.vue'
import ContractorSignup from '../views/marketplace/contractor/Signup.vue'
import ContractorRegistration from '../views/marketplace/contractor/Register.vue'
import ContractorForgotPassword  from '../views/marketplace/contractor/ForgotPassword.vue'
import ContractorJobs from '@/views/marketplace/contractor/Jobs.vue'
import ContractorViewJob from '@/views/marketplace/contractor/ViewJob.vue'
import ContractorAppliedJobs from '@/views/marketplace/contractor/AppliedJobs.vue'
import ContractorSettings from '@/views/marketplace/contractor/Settings.vue'
import ContractorTalentCommunityList from '@/views/marketplace/contractor/TalentCommunityList.vue'
import ContractorTalentCommunityDetail from '@/views/marketplace/contractor/TalentCommunityDetail.vue'
import ContractorCompanyPage from '@/views/marketplace/contractor/CompanyPage.vue'
import ContractorCompanySearch from '@/views/marketplace/contractor/CompanySearch.vue'
import ContractorProcessing from '@/views/marketplace/contractor/Processing.vue'
import ContractorPlatformHandoff from '@/views/marketplace/contractor/PlatformHandoff.vue'

import CompanyRegistration from '../views/marketplace/company/Register.vue'
import CompanyForgotPassword from '@/views/marketplace/company/ForgotPassword'
import CompanyDashboard from '../views/marketplace/company/Dashboard.vue'
import CompanyJobPosting from '@/views/marketplace/jobs/JobPosting.vue';
import CompanyManageJobs from '@/views/marketplace/company/ManageJobs.vue';
import CompanyViewJob from '@/views/marketplace/company/ViewJob.vue'
import CompanyCandidateView from '@/views/marketplace/company/ViewCandidate.vue'
import CompanyEditJob from '@/views/marketplace/company/EditJob.vue'
import CompanyPaymentHistory from '@/components/marketplace/company/PaymentHistory.vue'
import CompanyTalentPoolList from '@/views/marketplace/company/TalentPoolList.vue'
import CompanyTalentPoolDetail from '@/views/marketplace/company/TalentPoolDetail.vue'
import CompanySettings from '@/views/marketplace/company/Settings.vue'

import CompanyLogin from '../views/marketplace/company/Login.vue'
import CompanyLogout from '../views/marketplace/company/Logout.vue'
import CompanySignup from '../views/marketplace/company/Signup.vue'
import CompanyProfiles from '../views/marketplace/company/Profiles.vue'
import CompanyProfileEdit from '@/views/marketplace/company/ProfileEdit.vue'

// Admin
import AdminDashboard from '@/views/marketplace/admin/Dashboard'
import AdminCompanyList from '@/views/marketplace/admin/CompanyList'
import AdminContractorList from '@/views/marketplace/admin/ContractorList'
import AdminJobList from '@/views/marketplace/admin/JobList'
import AdminAuthentication from '@/views/marketplace/admin/Authentication'
import AdminAuthenticationVerify from '@/views/marketplace/admin/AuthenticationVerification'
import AdminViewContractor from '@/views/marketplace/admin/ViewContractor'
import AdminViewJob from '@/views/marketplace/admin/ViewJob'
import AdminManualJobs from '@/views/marketplace/admin/ManualJobs'
import AdminCvMatcher from '@/views/marketplace/admin/CvMatcher'


// ContractorView
import ContractorsView from '@/views/marketplace/contractor/ViewProfilePublic';



// Test
import TestView from '@/views/marketplace/TestView'

// Define the routes
const marketplaceRoutes = [
    {
      path: '/test',
      name: 'Test',
      component: TestView,
      meta: {
        contractorHeader: true
      }
    },
    // Contractor view
    {
        path: '/contractors/:uuid',
        name: 'ContractorsView',
        component: ContractorsView,
        meta: {
        }
    },
    // Admin authentication
    {
        path: '/dashboard/auth',
        name: 'AdminAuthentication',
        component: AdminAuthentication,
        meta: {
            blankHeader: true,
        }
    },
    {
        path: '/dashboard/auth/:token',
        name: 'AdminAuthenticationVerify',
        component: AdminAuthenticationVerify,
    },
    // Admin dashboard
    {
        path: '/dashboard/',
        name:'AdminDashboard',
        component: AdminDashboard,
        meta: {
          isAdminDashboard: true
        }
    },
    // Admin companies
    {
      path: '/dashboard/companies',
      name:'AdminCompanyList',
      component: AdminCompanyList,
      meta: {
        isAdminDashboard: true
      }
    },
    // Admin jobs
    {
      path: '/dashboard/jobs',
      name:'AdminJobList',
      component: AdminJobList,
      meta: {
        isAdminDashboard: true
      }
    },
    {
      path: '/dashboard/manual-jobs',
      name:'AdminManualJobs',
      component: AdminManualJobs,
      meta: {
        isAdminDashboard: true
      }
    },
    {
      path: '/dashboard/cv-matcher',
      name:'AdminCvMatcher',
      component: AdminCvMatcher,
      meta: {
        isAdminDashboard: true
      }
    },
    {
      path: '/dashboard/manual-jobs/:companyId',
      name:'AdminManualJobsCompany',
      component: AdminManualJobs,
      meta: {
        isAdminDashboard: true
      }
    },
    {
        path: '/dashboard/job/:jobUUID',
        name: 'AdminViewJob',
        component: AdminViewJob,
        meta: {
            isAdminDashboard: true
        }
    },
    // Admin contractors
    {
        path: '/dashboard/contractors',
        name: 'AdminContractorList',
        component: AdminContractorList,
        meta: {
          isAdminDashboard: true
        }
    },
    {
        path: '/dashboard/contractors/:contractorId',
        name: 'AdminViewContractor',
        component: AdminViewContractor,
        meta: {
          isAdminDashboard: true
        }
    },
    // Admin view job
    {
        path: '/dashboard/jobs/:companyId',
        name: 'AdminCompanyJobsList',
        component: AdminJobList,
        meta: {
            isAdminDashboard: true
        }
    },
    // Contractor registration
    {
        path: '/contractor/register',
        name: 'ContractorRegistrationStart',
        redirect: '/contractor/register/login',
        meta: {
          blankHeader: true,
          breadcrumbs: false
        }
    },
    {
        path: '/contractor/register/:step',
        name: 'ContractorRegistration',
        component: ContractorRegistration,
        meta: {
          blankHeader: true,
          breadcrumbs: false
        }
    },
    // Contractor Forgot password
    {
        path: '/contractor/handoff',
        name: 'ContractorPlatformHandoff',
        component: ContractorPlatformHandoff,
        meta: { breadcrumbs: false }
    },
    {
        path: '/contractor/forgot-password',
        name: 'ContractorForgotPassword',
        component: ContractorForgotPassword,
        meta: {
          blankHeader: true,
          breadcrumbs: false
        }
    },
    {
        path: '/contractor/jobs',
        name: 'ContractorJobs',
        component: ContractorJobs,
        meta: {
            contractorHeader: true,
            breadcrumbs: false,
            requiresContractorAuth: true
        }
    },
    {
        path: '/contractor/job/:jobId',
        name: 'ContractorViewJob',
        component: ContractorViewJob,
        meta: {
          contractorHeader: true,
          breadcrumbs: false,
          requiresContractorAuth: true
        }
    },
    {
        path: '/contractor/applied-jobs',
        name: 'ContractorAppliedJobs',
        component: ContractorAppliedJobs,
        meta: {
          contractorHeader: true,
          breadcrumbs: false,
          requiresContractorAuth: true
        }
    },
    {
        path: '/contractor/settings',
        name: 'ContractorSettings',
        component: ContractorSettings,
        meta: {
          contractorHeader: true,
          breadcrumbs: false,
          requiresContractorAuth: true
        }
    },
    {
        path: '/contractor/processing',
        name: 'ContractorProcessing',
        component: ContractorProcessing,
        meta: {
          blankHeader: true,
          breadcrumbs: false,
          requiresContractorAuth: true
        }
    },
    {
      path: '/contractor',
      component: DefaultLayout,
      children: [
        {
          path: '/marketplace',
          name: 'Contractor Index',
          redirect: '/contractor/profile'
        },
        {
            path: '/contractor/profile',
            name: 'ContractorProfile',
            component: ContractorProfile,
            meta: {
              contractorHeader: true,
              requiresContractorAuth: true,
              breadcrumbs: false
            }
        },
        {
          path: '/contractor/profile/preview',
          name: 'ContractorProfilePreview',
          component: ContractorProfilePreview,
          meta: {
            contractorHeader: true,
            requiresContractorAuth: true,
            breadcrumbs: false
          }
        },
        {
          path: '/contractor/profile/edit',
          name: 'ContractorProfileEdit',
          component: ContractorProfileEdit,
          meta: {
            contractorHeader: true,
            requiresContractorAuth: true,
            breadcrumbs: false
          }
        },
        {
          path: '/contractor/login',
          name: 'ContractorLogin',
          component: ContractorLogin,
          meta: {
            blankHeader: true,
            breadcrumbs: false
          }
        },
        {
          path: '/contractor/signup',
          name: 'ContractorSignup',
          component: ContractorSignup,
          meta: {
            contractorHeader: true,
            breadcrumbs: false
          }
        },
        {
          path: '/contractor/companies',
          name: 'ContractorCompanySearch',
          component: ContractorCompanySearch,
          meta: {
            contractorHeader: true,
            breadcrumbs: false,
            requiresContractorAuth: true
          }
        },
        {
          path: '/contractor/company/:slug',
          name: 'ContractorCompanyPage',
          component: ContractorCompanyPage,
          meta: {
            contractorHeader: true,
            breadcrumbs: false,
            requiresContractorAuth: true
          }
        },
        // Talent Communities
        {
          path: '/contractor/talent-communities',
          children: [
            {
              path: '',
              name: 'TalentCommunityList',
              component: ContractorTalentCommunityList,
              meta: {
                contractorHeader: true,
                breadcrumbs: false,
                requiresContractorAuth: true,
              }
            },
            {
              path: ':id',
              name: 'TalentCommunityDetail',
              component: ContractorTalentCommunityDetail,
              meta: {
                contractorHeader: true,
                breadcrumbs: false,
                requiresContractorAuth: true
              }
            }
          ]
        },
        {
          path: '/contractor/logout',
          name: 'ContractorLogout',
          component: ContractorLogout,
          meta: { contractorHeader: true }
        },
      ]
    },
    // Company
    {
      path: '/company',
      component: ScreenedLayout,
      children: [
        {
          path: 'login',
          name: 'CompanyLogin',
          component: CompanyLogin,
          meta: {
            blankHeader: true,
            breadcrumbs: false
          }
        },
        {
          path: '/company/signup',
          name: 'CompanySignup',
          component: CompanySignup,
          meta: {
            contractorHeader: true,
            breadcrumbs: false
          }
        },
        {
          path: '/company/logout',
          name: 'CompanyLogout',
          component: CompanyLogout,
          meta: { companyHeader: true }
        },
        {
            path: '/company/register',
            name: 'CompanyRegistration',
            component: CompanyRegistration,
            meta: {
              blankHeader: true,
              breadcrumbs: false
            }
        },
        {
            path: '/company/forgot-password',
            name: 'CompanyForgotPassword',
            component: CompanyForgotPassword,
            meta: {
              blankHeader: true,
            }
        },
        {
            path: '/company/dashboard',
            name: 'CompanyDashboard',
            component: CompanyDashboard,
            meta: {
              companyHeader: true,
              breadcrumbs: false
            }
        },
        {
            path: '/company/post-job',
            name: 'CompanyJobPosting',
            component: CompanyJobPosting,
            meta: {
              companyHeader: true,
              breadcrumbs: false
            }
        },
        {
            path: '/company/manage-jobs',
            name: 'CompanyManageJobs',
            component: CompanyManageJobs,
            meta: {
              companyHeader: true,
              breadcrumbs: false
            }
        },
        {
            path: '/company/view-job/:jobId',
            name: 'CompanyViewJob',
            component: CompanyViewJob,
            meta: {
              companyHeader: true,
              breadcrumbs: false
            }
        },
        {
            path: '/company/view-job/:jobId/applicant/:profile_hash',
            name: 'CompanyCandidateView',
            component: CompanyCandidateView,
            meta: {
              companyHeader: true,
              breadcrumbs: false
            }
        },
        {
            path: '/company/edit-job/:jobId',
            name: 'CompanyEditJob',
            component: CompanyEditJob,
            meta: {
              companyHeader: true,
              breadcrumbs: false
            }
        },
        {
          path: '/company/talent-pools',
          children: [
            {
              path: '',
              name: 'CompanyTalentPoolList',
              component: CompanyTalentPoolList,
              meta: {
                companyHeader: true,
                breadcrumbs: false,
              }
            },
            {
              path: ':id',
              name: 'CompanyTalentPoolDetail',
              component: CompanyTalentPoolDetail,
              meta: {
                companyHeader: true,
                breadcrumbs: false
              }
            },
            {
              path: ':poolId/member/:profile_hash',
              name: 'CompanyTalentPoolCandidateView',
              component: CompanyCandidateView,
              meta: {
                companyHeader: true,
                breadcrumbs: false
              }
            }
          ]
        },
        {
            path: '/company/payment-history',
            name: 'CompanyPaymentHistory',
            component: CompanyPaymentHistory,
            meta: {
              companyHeader: true,
              breadcrumbs: false
            }
        },
        {
          path: '/company/settings',
          name: 'CompanySettings',
          component: CompanySettings,
          meta: {
            companyHeader: true,
            breadcrumbs: false
          }
        },
        {
          path: '/company/profile/edit',
          name: 'CompanyProfileEdit',
          component: CompanyProfileEdit,
          meta: {
            companyHeader: true,
            breadcrumbs: false
          }
        }
      ]
    },
]

export default marketplaceRoutes;
